import {
    UPDATE_RACK_ATTEMPT,
} from 'shared_redux/actions';

export const updateSensorName = (rackId, sensor_name) => ({ type: UPDATE_RACK_ATTEMPT, rackId, payload: {sensor_name} });

export const updateRackNumber = (rackId, number) => ({ type: UPDATE_RACK_ATTEMPT, rackId, payload: {number: parseInt(number)} });
